import { GameStats } from '../../lib/localStorage'
import { Progress } from './Progress'

type Props = {
  gameStats: GameStats
  isGameWon: boolean
  numberOfGuessesMade: number
  highlightCurrent?: boolean
  mergeStats?: GameStats
}

const isCurrentDayStatRow = (
  isGameWon: boolean,
  numberOfGuessesMade: number,
  i: number
) => {
  return isGameWon && numberOfGuessesMade === i + 1
}

export const Histogram = ({
  gameStats,
  isGameWon,
  numberOfGuessesMade,
  highlightCurrent=true,
  mergeStats,
}: Props) => {
  const winDistribution = gameStats.winDistribution
  let maxValue = Math.max(...winDistribution, 1)
  if(mergeStats) {
    const mergedDistribution = winDistribution.map((v, i) => v + mergeStats.winDistribution[i])
    maxValue = Math.max(...mergedDistribution, 1)
  }

  return (
    <div className="columns-1 justify-left m-2 text-sm dark:text-white">
      {winDistribution.map((value, i) => (
        <div key={i} className="flex flex-row">
          <Progress
          key={i}
          index={i}
          isCurrentDayStatRow={highlightCurrent && isCurrentDayStatRow(
            isGameWon,
            numberOfGuessesMade,
            i
          )}
          size={90 * (value / maxValue)}
          label={String(value)}
          />
          {mergeStats && mergeStats.winDistribution[i] > 0 && <Progress
          key={i + 'm'}
          index={i}
          isCurrentDayStatRow={highlightCurrent && isCurrentDayStatRow(
            isGameWon,
            numberOfGuessesMade,
            i
          )}
          size={90 * (mergeStats.winDistribution[i] / maxValue)}
          label={String(mergeStats.winDistribution[i])}
          merge={true}
          />}
        </div>
      ))}
    </div>
  )
}
